"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./help-and-faq.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./help-and-faq.component");
var styles_HelpAndFaqComponent = [i0.styles];
var RenderType_HelpAndFaqComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_HelpAndFaqComponent, data: {} });
exports.RenderType_HelpAndFaqComponent = RenderType_HelpAndFaqComponent;
function View_HelpAndFaqComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "container pt-2 pb-2"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" HELP AND FAQ\n"]))], null, null); }
exports.View_HelpAndFaqComponent_0 = View_HelpAndFaqComponent_0;
function View_HelpAndFaqComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-help-and-faq", [], null, null, null, View_HelpAndFaqComponent_0, RenderType_HelpAndFaqComponent)), i1.ɵdid(1, 114688, null, 0, i2.HelpAndFaqComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_HelpAndFaqComponent_Host_0 = View_HelpAndFaqComponent_Host_0;
var HelpAndFaqComponentNgFactory = i1.ɵccf("app-help-and-faq", i2.HelpAndFaqComponent, View_HelpAndFaqComponent_Host_0, {}, {}, []);
exports.HelpAndFaqComponentNgFactory = HelpAndFaqComponentNgFactory;
